export const FILTER_IMPORTANCE = "importance";
export const FILTER_CHAPTER = "chapter";
export const FILTER_CATEGORY = "category";
export const FILTER_ANSWERD = "answerd";
export const FILTER_FINDING_IMPORTANCE = "finding_importance";

export const SORT_IMPORTANCE = "importance";
export const SORT_FINDING_IMPORTANCE = "finding_importance";
export const SORT_CATEGORY = "category";
export const SORT_CHAPTER = "chapter";
export const SORT_NO = "no";

export const GROUP_IMPORTANCE = "importance";
export const GROUP_CATEGORY = "category";
export const GROUP_CHAPTER = "chapter";
